(() => {
  if (window.__rbGallery) return;
  window.__rbGallery = true;
  const CSS_URL = document.currentScript && document.currentScript.dataset.css;

  const ensureCss = () => {
    if (!CSS_URL || document.getElementById('rb-sliders-css')) return;
    const link = document.createElement('link');
    link.id = 'rb-sliders-css';
    link.rel = 'stylesheet';
    link.href = CSS_URL;
    document.head.appendChild(link);
  };

  const icon = (path) =>
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="' + path + '"/></svg>';

  const make = (cls, label, path) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rb-gal__btn rb-gal__btn--' + cls;
    btn.setAttribute('aria-label', label);
    btn.innerHTML = icon(path);
    return btn;
  };

  const init = (gallery) => {
    if (!gallery || gallery.dataset.rbNav) return;
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;
    const buttons = () => Array.from(gallery.querySelectorAll('.thumbnail-list button.thumbnail'));
    const total = buttons().length;
    if (total < 2) {
      gallery.dataset.rbNav = 'single';
      return;
    }
    gallery.dataset.rbNav = 'ready';
    ensureCss();
    viewer.classList.add('rb-gal');

    const prev = make('prev', 'Previous image', 'M15 5l-7 7 7 7');
    const next = make('next', 'Next image', 'M9 5l7 7-7 7');
    const count = document.createElement('span');
    count.className = 'rb-gal__count';
    count.setAttribute('aria-live', 'polite');

    const current = () => {
      const index = buttons().findIndex((b) => b.getAttribute('aria-current') === 'true');
      return index < 0 ? 0 : index;
    };
    const render = () => {
      count.textContent = current() + 1 + ' / ' + total;
    };
    const go = (step) => {
      const list = buttons();
      list[(current() + step + list.length) % list.length].click();
      setTimeout(render, 60);
    };

    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    viewer.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') go(-1);
      if (event.key === 'ArrowRight') go(1);
    });
    viewer.append(prev, next, count);
    render();

    const list = gallery.querySelector('.thumbnail-list');
    if (list) new MutationObserver(render).observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-current'] });
    viewer.addEventListener('slideChanged', render);
  };

  const run = () => document.querySelectorAll('media-gallery').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();